import React, {Component} from "react";

class FilterDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownExpanded: false,
      currentValue: "all"
    };
  }

  getCurrent() {
    if (this.props.options) {
      let item = this.props.options.find(o => o.value === this.props.selectedStatus);
      if (item) return item.label;
    }
    return "All";
  }

  render() {
    return (
        <div className="dropdown__wrapper">
          <button
              className="dropdown__toggler"
              onClick={() => this.onClickToggleDropdown()}
          >
            {this.getCurrent()}
        </button>
        <ul className={"dropdown__container " + (this.state.isDropdownExpanded ? "expanded" : "")}>
          {this.props.options.map(item => {
            return (
                <li className={item.value === this.props.selectedStatus ? "active" : ""}
                    key={item.value}
                    onClick={() => this.onClickChangeAccountsFilter(item)}
                >
                  {item.label}
                </li>
            );
          })}
        </ul>
      </div>
    );
  }

  onClickToggleDropdown() {
    this.setState({
      isDropdownExpanded: !this.state.isDropdownExpanded
    });
  }

  onClickChangeAccountsFilter(status) {
    if (status.value !== this.state.currentValue) {
      this.props.handleAccountsFilter(status.value);
    }
    this.setState({
      isDropdownExpanded: false,
      currentValue: status.value
    });
  }
}

export default FilterDropDown;



// WEBPACK FOOTER //
// ./src/common/Filter/FilterDropDown.js